export default __webpack_public_path__ + "static/media/customer_black.9cfc4ff6.svg";